module.exports = __webpack_public_path__ + "img/pc1.4ef7134d.png";